import { render, staticRenderFns } from "./animFlow.vue?vue&type=template&id=36dce55e&"
import script from "./animFlow.vue?vue&type=script&lang=js&"
export * from "./animFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports